<div class="max_width">

    <div class="nav-space"></div>
    <div class="about_me_field">
        <div class="about_me">
            <h1>{{translateText.aboutMeText[translateText.language]['h1']}}</h1>
            <div class="description">
                <span>{{translateText.aboutMeText[translateText.language]['aboutMe']}}</span>

                <div class="description_personal_things">
                    <div class="personal_things">
                        <div class="personal_things_icon">
                            <img src="../../assets/img/about_me/bulb.png" alt="">
                        </div>
                        <span>{{translateText.aboutMeText[translateText.language]['bulb']}}</span>
                    </div>
                    <div class="personal_things">
                        <div class="personal_things_icon">
                            <img src="../../assets/img/about_me/puzzle.png" alt="">
                        </div>
                        <span>{{translateText.aboutMeText[translateText.language]['puzzle']}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="image_head">
            <img src="../../assets/img/about_me/head.png" alt="">
            <div class="orange_line"></div>
        </div>
    </div>
</div>